// extracted by mini-css-extract-plugin
module.exports = {"content":"BackButtonContent_content__1qj8W","title":"BackButtonContent_title__2C0Vo","subtitle":"BackButtonContent_subtitle__1jlZJ"};